"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var chatWarningModal_module_scss_1 = __importDefault(require("@cdo/apps/aichat/views/chatWarningModal.module.scss"));
var typography_1 = require("@cdo/apps/componentLibrary/typography");
var AccessibleDialog_1 = __importDefault(require("@cdo/apps/templates/AccessibleDialog"));
var Button_1 = __importDefault(require("@cdo/apps/templates/Button"));
var WarningModal = function () {
    var _a = (0, react_1.useState)(true), open = _a[0], setOpen = _a[1];
    var onClose = function () {
        setOpen(false);
    };
    if (open) {
        return (react_1.default.createElement(AccessibleDialog_1.default, { onClose: onClose, className: chatWarningModal_module_scss_1.default.chatWarningModal },
            react_1.default.createElement(typography_1.Heading2, null, "Remember to chat responsibly!"),
            react_1.default.createElement("button", { type: "button", onClick: onClose, className: chatWarningModal_module_scss_1.default.xCloseButton },
                react_1.default.createElement("i", { id: "x-close", className: "fa-solid fa-xmark" })),
            react_1.default.createElement("hr", null),
            react_1.default.createElement(typography_1.BodyTwoText, null,
                react_1.default.createElement(typography_1.StrongText, null, "All messages sent to AI Tutor are recorded")),
            react_1.default.createElement(typography_1.BodyTwoText, null, "Inappropriate messages will be flagged and your teacher will be notified."),
            react_1.default.createElement("br", null),
            react_1.default.createElement(typography_1.BodyTwoText, null, "In order to protect your privacy, anything considered personal information (name, phone number, address, etc.) should not be submitted to AI Tutor."),
            react_1.default.createElement("hr", null),
            react_1.default.createElement("div", { className: chatWarningModal_module_scss_1.default.bottomSection },
                react_1.default.createElement(Button_1.default, { onClick: onClose, color: Button_1.default.ButtonColor.brandSecondaryDefault, text: "Ask AI Tutor" }))));
    }
    else {
        return null;
    }
};
exports.default = WarningModal;
